import React from "react";
import CardPaymentView from "./CardPaymentView";

const CardPaymentContainer = () => {
  return <CardPaymentView />;
};

export default CardPaymentContainer;
